<template>
  <div class="apply-status">
    <div class="title" :class="status.class">
      <i class="main-icon" :class="status.icon" />
      <h1>{{ status.name }}</h1>
    </div>
    <h2>{{ status.desc }}</h2>
    <a v-if="data.status === 1" href="https://anyteach.cn/store">
      点击前往店家后台
      <i class="anyteachicon anyteach-arrow-right" />
    </a>
    <div v-if="status.note" class="note">{{ status.note }}</div>
    <div class="info">
      <div class="row">
        <div class="left">店家账号</div>
        <div class="right">{{ data.name }}</div>
      </div>
      <div v-if="data.status === 1" class="row">
        <div class="left">店家密码</div>
        <div class="right">{{ data.password_text }}</div>
      </div>
      <div class="row">
        <div class="left">合作期限</div>
        <div class="right">{{ data.start_time | date }} 至 {{ data.end_time | date }}</div>
      </div>
      <div class="row">
        <div class="left">礼品信息</div>
        <div class="right">{{ data.gift_a[0].name }} · ¥{{ data.gift_a[0].price }}</div>
      </div>
      <div v-if="data.status === 1" class="row">
        <div class="left">物料素材</div>
        <div
          class="right"
        >{{ data.material_poster && data.material_display ? "已制作，可在后台下载" : "等待制作" }}</div>
      </div>
    </div>
    <a class="question" @click=" $emit('question')">
      <i class="anyteachicon anyteach-question-circle" />
      补贴将如何发放
    </a>
  </div>
</template>

<script>
import { storeStatus, filters } from "./utils"
export default {
  props: ["data"],
  data() {
    return {
    }
  },
  filters,
  computed: {
    status() {
      return storeStatus[this.data.status]
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./style.scss";

.apply-status {
  text-align: center;
  .main-icon {
    font-size: 55px;
    padding-bottom: 5px;
    line-height: 1;
    display: block;
  }
  h1 {
    @include avenir-demi();
    font-size: 1.25rem;
    font-weight: bold;
    margin-bottom: 10px;
  }
  h2 {
    font-weight: 400;
    font-size: 0.9rem;
  }
  .secondary {
    opacity: 0.6;
    margin: 0 0 10px 0;
  }
  a {
    font-weight: 500;
    color: $primary;
    font-size: 0.8rem;
  }

  .info {
    border-top: 1px solid #eee;
    padding: 5px 0 0 0;
    margin: 15px 0 0 0;

    .row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 0.9rem;
      .left {
        opacity: 0.6;
        min-width: 65px;
        text-align: left;
      }
      .right {
        text-align: right;
      }
    }
  }

  .note {
    font-size: 0.8rem;
    opacity: 0.6;
  }

  .question {
    display: block;
    margin: 10px 0 -5px 0;
  }
}
</style>